module.exports = __webpack_public_path__ + "img/techManager.3b3b12d.png";